export default function CheckCircle({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM17.1178 8.21368C17.5521 8.55489 17.6275 9.18355 17.2863 9.61782L12.1082 16.2081C11.5397 16.9317 10.4395 16.9194 9.88738 16.1832L7.2 12.6C6.86863 12.1582 6.95817 11.5314 7.4 11.2C7.84183 10.8686 8.46863 10.9582 8.8 11.4L11.0184 14.3579L15.7137 8.38218C16.0549 7.9479 16.6835 7.87247 17.1178 8.21368Z"
        fill="currentColor"
      />
    </svg>
  )
}
